import React from "react";
import styles from "../characteristicCustomForm.module.scss";
import { useSelector } from "react-redux";

export const ViewCustomForm = ({ getForm, customFormBuilder }) => {
  const showViewForm = useSelector((state) => state.forms.viewForms);

  const viewForm = getForm?.formdata || [];
  const formList = customFormBuilder || [];

  if (!viewForm.length) return null;

  return (
    <>
      {viewForm.map((item, index) => {
        const question = formList.find((f) => f.id === item.id);
        if (!question) return null;

        const options = item?.options || [];
        const hasViewData = showViewForm?.formdata?.length > 0;

        const renderValues = () => {
          if (!hasViewData) return "";

          if (question?.type === "text") {
            return <div className={`col-form-label ${styles.content_spec}`}>{item.value}</div>;
          }

          if (options.includes("noneoftheabove")) {
            return <div className={`col-form-label ${styles.content_spec}`}>None of the above</div>;
          }

          if (options.includes("alloftheabove")) {
            return question.options
              ?.filter((opt) => opt.key && opt.key !== "alloftheabove" && opt.key !== "noneoftheabove")
              .map((opt, i) => (
                <div key={i} className={`col-form-label ${styles.content_spec}`}>
                  {opt.key !== "other" ? opt.value : item.value}
                </div>
              ));
          }

          if (options.length > 0 && options?.[0] !== "") {
            return options.map((optVal, i) => {
              if (!optVal) return null;

              const optionData = question.options?.find((f) => f?.key === optVal);

              return (
                <div key={i} className={`col-form-label ${styles.content_spec}`}>
                  {(optionData?.key !== "other") ? optionData?.value : item.value}
                </div>
              );
            });
          }

          return item.value;
        };

        return (
          <div className={`col-12 ${styles.col_spec}`} key={index}>
            <label className={`col-6 col-form-label ${styles.label_spec}`}>{question.desc}</label>
            <div className="col-5 p-0">{renderValues()}</div>
          </div>
        );
      })}
    </>
  );
};
